import { Stack, styled } from "@mui/material";

export const EditMFIUserWrapper = styled(Stack)(() => {
    return {
        gap: "var(--flex-gap)",
        padding: "var(--basic-padding)",
        backgroundColor: "var(--light-color)",
        borderRadius: "16px",
        overflow: "hidden",
        "& form": {
            display: "flex",
            flexDirection: "column",
            gap: "var(--flex-gap)",
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
        "& .user-avatar": {
            width: '55px',
            height: '48px',
            borderRadius: '50%',
            objectFit: 'cover'
        },
    }
})